<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="'日期'">
              <a-range-picker
                v-model='queryParam.date'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item :label="'批次号'">
              <a-input
                placeholder="请输入批次号"
                v-model="queryParam.batchNo"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="6">
            <a-form-item :label="'类型'">
              <a-select v-model="queryParam.type">
                <a-select-option value="1">
                  重复用户
                </a-select-option>
                <a-select-option value="2">
                  新户
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='3' :sm='4'>
            <a-button style='margin-left: 20px' type='primary' @click='loadData()'>查询</a-button>
          </a-col>
          <a-col :md='4' :sm='4'>
                      <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                        <a-button type='primary' @click='searchReset' icon='reload'
                                  style='margin-left: 20px'>{{ $t('reset')
                          }}</a-button>
                      </span>
          </a-col>
          <a-col :md='3' :sm='3'>
            <a-upload
              name='file'
              :multiple='true'
              :action="'/api/web/webpublic/white/uploadWhiteList/test'"
              :headers='getHeaders()'
              :data='uploadDataParam'
            >
              <a-button @click='clickUploadFile' style='margin-left: 8px'>
                <a-icon
                  type='upload' />
                导量白名单
              </a-button>
            </a-upload>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
              <span slot="action" slot-scope="text, record">
                <a-button style="margin-left: 10px" type="primary" :disabled="isButtonDisabled" @click="lssueAnOrder(record)">分单</a-button>

              </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getLoanList, getLimitData, importRecordPayment } from '@/webpublicapi/TripartiteLoan'
import { getHeaders } from '@/utils/request'
import { datetime,now } from 'mockjs2/src/mock/random/date'
import { assignTasks, queryWhiteList } from '@/webpublicapi/ImportWhite'
import moment from 'moment/moment'

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  FOLLOW: 'importPayoutOrder.'
}
export default {
  name: 'importPayoutOrder',
  components: {},
  data() {
    return {
      isButtonDisabled: false, // 初始状态下按钮是可用的
      checkbosNum: [],
      batchIdNum: '',
      selectedRowKeys: [],
      QueryOrderValue: '正序',
      NewUsersLoansNum: '',
      RegularUsersLoansNum: '',
      visdialog: false,
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      dataSourceTotal: [],
      departments: [],
      groupAll: [],
      normalConfigList: [],
      // 查询条件
      queryParam: {
        batchNo: undefined,
        type: '1',
        date: [moment(), moment()],

      },
      limitParam: '',//查询条件
      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      uploadDataParam: {},
      payChannelRes: [
        {
          payChannel: 'moneySpace',
          data: {
            payOutIdIndex: 8,
            statusIndex: 5,
            sheetIndex: 0,
            payChannel: 'moneySpace',
            successMarkMsg: 'success'
          }
        }
      ]
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '导入日期',
          align: 'left',
          dataIndex: 'date'
        },
        {
          title: '批次 No',
          align: 'center',
          dataIndex: 'batchNo'
        },
        {
          title: '批次渠道',
          align: 'center',
          dataIndex: 'batchChannel'
        },
        {
          title: '批次总数',
          align: 'center',
          dataIndex: 'count'
        },
        {
          title: '有效数量',
          align: 'center',
          dataIndex: 'validCount'
        },
        {
          title: '无效数量',
          align: 'center',
          dataIndex: 'invalidCount'
        },
        {
          title: '重复数量',
          align: 'center',
          dataIndex: 'repeatCount'
        },
        {
          title: '电销分单数量',
          dataIndex: 'telemarketingCount',
          align: 'center',
        },
        {
          title: '提交数量',
          align: 'center',
          dataIndex: 'submitCount'
        },
        {
          title: '机审通过数量',
          align: 'center',
          dataIndex: 'accCount'
        },
        {
          title: '放款数量',
          dataIndex: 'payoutCount',
          align: 'center',
        },

        {
          title: '还款数量',
          align: 'center',
          dataIndex: 'repayCount'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }

      ]
    }
  },
  created() {
    // this.getTime()
    this.loadData(1)
  },
  methods: {
    downloadBtn(record) {
      console.log('record！！！', record)
      let orderIds = record.orderIds
      console.log('record---batchId！！！', orderIds)
      importRecordPayment(Object.assign({}, { orderIds })).then((res) => {
        console.log('importRecordPayment-----》', res)
        // 创建可下载的URL地址
        const downloadUrl = URL.createObjectURL(res)
        // 创建a标签
        const a = document.createElement('a')
        a.href = downloadUrl
        // 设置要保存的文件名
        a.download = record.createTime + ' ' + record.batchId + '.xlsx'
        // 模拟点击a标签，触发下载
        a.click()
        // 清理URL对象
        URL.revokeObjectURL(downloadUrl)
        this.$message.success('下载成功！')
        this.loadData(1)
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.checkbosNum = selectedRows
      console.log('选择了一行数据！！！')
      if (selectedRows.length) {
        this.batchIdNum = selectedRows[selectedRows.length - 1].batchId
        console.log('selectedRowKeys---->', selectedRowKeys)
        console.log('selectedRows--->', selectedRows)
        console.log(' this.batchIdNum--->', this.batchIdNum)
        this.uploadDataParam.batchId = this.batchIdNum
        console.log(' this.uploadDataParam--->', this.uploadDataParam)
      }
    },
    clickUploadFile() {
    },
    QueryOrderChange(e) {
      console.log('下拉框改变了!!!', e)
      this.QueryOrderValue = e
    },
    NewUsersLoansNumChange(e) {
      console.log('新用户放款数变了', e)
      this.NewUsersLoansNum = e
    },
    payChannelChange(value) {
      console.log('value是什么？', value)
      console.log('this.payChannelRes？', this.payChannelRes)
      var isIn = false
      for (const payChannelInfo of this.payChannelRes) {
        if (payChannelInfo.payChannel === value) {
          this.uploadDataParam = payChannelInfo.data
          isIn = true
        }
      }
      this.uploadDataParam.batchId = this.batchIdNum
      if (!isIn) {
        this.uploadDataParam = {}
      }
      console.log('this.uploadDataParam', this.uploadDataParam)
    },
    // getTime() {
    //   this.queryParam.time = []
    //   var nowDate = new Date()
    //   this.queryParam.time[0] = moment(nowDate.setDate(nowDate.getDate() - 7))
    //   this.queryParam.time[1] = moment(new Date())
    //
    // },
    getHeaders() {
      return getHeaders()
    },
    searchQuery() {
      this.loadData(1)
    },

    searchanDownload() {
      console.log('点击了生成放款批次!!')
      this.loadLimitData(1)

    },
    loadLimitData(arg) {
      // console.log('旧', this.RegularUsersLoansNum)
      // console.log('新', this.NewUsersLoansNum)
      // console.log('选的正序还是倒序?', this.QueryOrderValue)
      if (this.QueryOrderValue == '正序') {
        this.QueryOrderValue = '1'
      }
      console.log('this.RegularUsersLoansNum新---', this.RegularUsersLoansNum)
      console.log('this.NewUsersLoansNum旧---', this.NewUsersLoansNum)
      if (this.RegularUsersLoansNum >= 0 && (this.RegularUsersLoansNum !== '' && this.RegularUsersLoansNum !== null && this.RegularUsersLoansNum !== undefined)) {
        console.log('old条件成立')
      } else this.$message.error('老户放款数量不能为空！')
      if (this.NewUsersLoansNum >= 0 && (this.NewUsersLoansNum !== '' && this.NewUsersLoansNum !== null && this.NewUsersLoansNum !== undefined)) {
        console.log('new条件成立')
      } else this.$message.error('新户放款数量不能为空！')

      this.limitParam = `${this.NewUsersLoansNum},${this.RegularUsersLoansNum},${this.QueryOrderValue}`
      let limits = this.limitParam //字符串
      console.log('准备发请求咯!!!', limits)
      if ((this.NewUsersLoansNum !== '' && this.NewUsersLoansNum !== null && this.NewUsersLoansNum !== undefined) && (this.RegularUsersLoansNum !== '' && this.RegularUsersLoansNum !== null && this.RegularUsersLoansNum !== undefined) && this.QueryOrderValue) {
        console.log('可以发请求')
        getLimitData(Object.assign({}, { limits })).then((res) => {
          console.log('getLimitData-----》', res)
          if (res.size == 0) {
            this.$message.error('暂无放款数据！')
          } else {
            // 创建可下载的URL地址
            const downloadUrl = URL.createObjectURL(res)
            // 创建a标签
            const a = document.createElement('a')
            a.href = downloadUrl
            // 设置要保存的文件名
            // a.download = 'document.xlsx'
            a.download = new Date().getTime() + '.xlsx'
            // 模拟点击a标签，触发下载
            a.click()
            // 清理URL对象
            URL.revokeObjectURL(downloadUrl)
            this.$message.success('下载成功！')
            this.loadData(1)
          }

        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      } else {
        console.log('不可以发请求！')
      }
    },
    lssueAnOrder(record){
      this.isButtonDisabled = true;
      console.log("params ===>" , record.batchNo)
      let param = {
        batchNo : record.batchNo
      }
      assignTasks(Object.assign({}, param)).then((res) => {
        if (res.code === 1000) {
          return alert('分单成功')
        }
      })
    },
    loadData(arg) {
      this.isButtonDisabled = false;
      var params = this.getQueryParams()// 查询条件

      queryWhiteList(Object.assign({}, params)).then((res) => {
        console.log('加载默认数据列表的接口')
        if (res.code === 1000) {
          this.total = res.data
          this.dataSource = res.data
          console.log('dataSource--->', this.dataSource)
          console.log('this.total', this.total)
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    }
    ,
    getQueryParams() {
      const { date } = this.queryParam
      const data = {
        ...this.queryParam,//...将原始的this.queryParam对象中的属性复制到data对象中
        dateBegin: (date && date.length) ? this.transformTime(date[0]) : undefined,
        dateEnd: (date && date.length) ? this.transformTime(date[1]) : undefined
        //根据条件判断，将settleTime数组中的第一个元素和第二个元素通过transformTime方法转换后赋值给data对象的beginDate和endDate属性。
      }
      let param = this.queryParam

      param = Object.assign(data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize

      return filterObj(param)
    }
    ,
    transformTime(time) {
      return time.format('YYYY-MM-DD')
    }
    ,
    handleTableChange(pageNum, pageSize) {
      console.log(1111)
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    }
    ,
    // 重置搜索框的内容
    searchReset() {
      console.log('重置！')
      this.queryParam.batchNo = undefined
      this.queryParam.type = '1'
      this.queryParam.date = [moment(), moment()]
      this.loadData()
    }
    ,
    handleChangeUpload(info) {
      console.log(2222)
      console.log('info----->', info)
      console.log(' queryParam.payChannel--->', this.queryParam.payChannel)
      // if (this.queryParam.payChannel==undefined) {
      //   this.$message.error('请选择方式！')
      //   console.log('没选支付方式')
      // } else {
      //   this.openFileDialogOnClick = true
      console.log('选择了支付方式')
      //debugger;
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        console.log(1)
      }
      if (info.file.status === 'done') {
        console.log('上传成功！')
        if (info.file.response.code === 1000) {
          //alert('handle success!');
          this.$message.success(`${info.file.name} file uploaded successfully`)
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        console.log(3)
        //this.$message.error(`${info.file.name} file upload failed.`);
        alert('system error!')
      }
      // }
      console.log('准备刷新页面！')
      this.loadData(1)
      console.log('页面刷新成功！')
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
